// extracted by mini-css-extract-plugin
export default {"heading":"OrganizationTextBlockAddTemplate_heading__xaCu8","buttonLink":"OrganizationTextBlockAddTemplate_buttonLink__dtmsT"};